import Controller from "@ember/controller"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"

const EMAILS = {
  admin: {
    // Michael Richardson
    elem: "matthew+elemprincipal@commoncurriculum.com",
    // Camille Blake
    middle: "matthew+middleprincipal@commoncurriculum.com",
    // Richard Montgomery
    high: "matthew+highprincipal@commoncurriculum.com",
    // Demo Admin
    district: "matthew+demodistrictadmin@commoncurriculum.com",
  },
  teacher: {
    // Chelsea Reyes
    elem: "matthew+grade1a@commoncurriculum.com",
    // Bailey Schuman
    middle: "matthew+grade6science@commoncurriculum.com",
    // Robert Kim
    high: "matthew+grade9matha@commoncurriculum.com",
  },
} as const

export default class DistrictDemoController extends Controller {
  @service declare rpc: Rpc
  @service declare session: Session

  @action
  stopImpersonating() {
    this.session.stopImpersonating()
    window.location.reload()
  }

  @action
  impersonate(role: "admin" | "teacher", school: "elem" | "middle" | "high") {
    const email = EMAILS[role][school]
    if (this.session.isImpersonating) this.session.stopImpersonating()
    this.rpc
      .execute("IMPERSONATE_BY_EMAIL", {
        email,
      })
      .then((data) => {
        let userId = this.session.impersonate(data.userId, data.token)
        window.open(`/users/${userId}`)
      })
  }
}
